import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startSollstellungStatus: 'idle',
    startSollstellungError: undefined as any,
    loadUserParamsSollstellungStatus: 'idle',
    loadUserParamsSollstellungError: undefined as any,

    sollstellungList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startSollstellung = createAsyncThunk('sollstellungSlice/startSollstellung', async ({ sollstellung }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartSollstellung/`,
        prepareData(sollstellung),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startSollstellungStatus } = getState().sollstellungSlice
        return startSollstellungStatus !== 'pending'
    }
})

export const loadUserParamsSollstellung = createAsyncThunk('sollstellungSlice/loadUserParamsSollstellung', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsSollstellung/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsSollstellungStatus } = getState().sollstellungSlice
        return loadUserParamsSollstellungStatus !== 'pending'
    }
})

const SollstellungSlice = createSlice({
    name: 'sollstellungSlice',
    initialState,
    reducers: {
        resetstartSollstellung: (state) => {
            state.job = undefined
            state.startSollstellungError = undefined
        },
        resetstartSollstellungError: (state) => {
            state.startSollstellungError = undefined
        },
        resetloadUserParamsSollstellung: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsSollstellungError = undefined
        },
        resetloadUserParamsSollstellungError: (state) => {
            state.loadUserParamsSollstellungError = undefined
        },
        removeFromSollstellungListById: (state, action) => {
            state.sollstellungList = state.sollstellungList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromSollstellungListByIds: (state, action) => {
            state.sollstellungList = state.sollstellungList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.sollstellungList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startSollstellungStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.sollstellungList = []
            state.startSollstellungStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startSollstellung.pending, (state) => {
            state.startSollstellungStatus = 'pending'
            state.startSollstellungError = undefined
        })
        builder.addCase(startSollstellung.fulfilled, (state, action) => {
            state.startSollstellungStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startSollstellung.rejected, (state, action) => {
            state.startSollstellungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startSollstellungError = action.error.message
            } else {
                state.startSollstellungError = action.payload
            }
        })

        builder.addCase(loadUserParamsSollstellung.pending, (state) => {
            state.loadUserParamsSollstellungStatus = 'pending'
            state.loadUserParamsSollstellungError = undefined
        })
        builder.addCase(loadUserParamsSollstellung.fulfilled, (state, action) => {
            state.loadUserParamsSollstellungStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsSollstellung.rejected, (state, action) => {
            state.loadUserParamsSollstellungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsSollstellungError = action.error.message
            } else {
                state.loadUserParamsSollstellungError = action.payload
            }
        })

    }
})

export const {
    resetstartSollstellung,
    resetstartSollstellungError,
    resetloadUserParamsSollstellung,
    resetloadUserParamsSollstellungError,
    removeFromSollstellungListById,
    removeFromSollstellungListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = SollstellungSlice.actions
export default SollstellungSlice.reducer
